import React, { memo, ReactElement } from 'react'
import { CheckBoxTypes } from './checkbox.types'
import InputRadio from '../../../../src/containers/UtmGenerator/Components/InputRadio'

function Checkbox(props: CheckBoxTypes): ReactElement {
  return (
    <InputRadio
      name="traffic"
      checked={props.checked}
      label={props.text}
      value={props.name}
      onChange={props.onChange}
    />
  )
}

export default memo(Checkbox)
